import { render, staticRenderFns } from "./holiday-form.vue?vue&type=template&id=a15716d2&"
import script from "./holiday-form.vue?vue&type=script&lang=js&"
export * from "./holiday-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports